import React, { cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Modal from 'components/modals/Modal';

import cxHelpers from 'util/className';

export const ARROW_TYPES = [undefined, 'curved', 'slightlyCurved'];
export const SCRIM_DEFAULT_ZINDEX = 10001;
const MODAL_DEFAULT_BACKGROUND = 'rgba(25, 35, 41, 0.83)';

@cxHelpers('ScrimWrapper')
export default class ScrimWrapper extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeCallback: PropTypes.func.isRequired,
    content: PropTypes.node.isRequired,
    zIndex: PropTypes.number,
    arrowFlipX: PropTypes.bool,
    arrowFlipY: PropTypes.bool,
    modalStyle: PropTypes.object,
    arrowStyle: PropTypes.object,
    arrowRotate: PropTypes.number,
    arrowType: PropTypes.oneOf(ARROW_TYPES),
    arrowWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    arrowTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    arrowLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    arrowRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    arrowBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    arrowWidth: 200,
    arrowStyle: {},
    arrowFlipX: false,
    arrowFlipY: false,
    zIndex: SCRIM_DEFAULT_ZINDEX,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  transformStyle = () => {
    const { arrowRotate, arrowFlipX, arrowFlipY } = this.props;
    if (!arrowRotate && !arrowFlipX && !arrowFlipY) {
      return 'none';
    }

    const transformations = [];

    if (arrowFlipX) {
      transformations.push('scaleX(-1)');
    }

    if (arrowFlipY) {
      transformations.push('scaleY(-1)');
    }

    if (arrowRotate) {
      transformations.push(`rotate(${arrowRotate}deg)`);
    }

    return transformations.join(' ');
  };

  handleClickOutside = e => {
    if (
      this.props.isOpen &&
      !this.modal.contains(e.target) &&
      this.modal !== e.target
    ) {
      this.props.closeCallback(e);
    }
  };

  handleModalRef = modal => (this.modal = modal);

  renderArrow() {
    const {
      zIndex,
      arrowType,
      arrowWidth,
      arrowTop,
      arrowLeft,
      arrowStyle,
      arrowRight,
      arrowBottom,
    } = this.props;

    const style = { transform: this.transformStyle(), ...arrowStyle };

    return (
      <Box
        absolute
        style={style}
        w={arrowWidth}
        top={arrowTop}
        zIndex={zIndex}
        left={arrowLeft}
        right={arrowRight}
        bottom={arrowBottom}
      >
        <img src={require(`./images/${arrowType}.svg`)} />
      </Box>
    );
  }

  render() {
    const { isOpen, content, children, arrowType, zIndex } = this.props;

    if (!isOpen) {
      return children;
    }

    const modalStyle = {
      overlay: {
        zIndex: zIndex - 1,
        backgroundColor: MODAL_DEFAULT_BACKGROUND,
      },
      ...this.props.modalStyle,
    };

    return (
      <Box className={this.cx()}>
        <Box relative onClick={this.props.closeCallback}>
          {cloneElement(children, { zIndex, relative: true, bg: 'white' })}
          {arrowType && this.renderArrow()}
        </Box>
        <Box getRef={this.handleModalRef}>
          <Modal
            auto
            isOpen
            noPadding
            fullWidth
            forceOpen
            transparent
            hideCloseIcon
            style={modalStyle}
          >
            {content}
          </Modal>
        </Box>
      </Box>
    );
  }
}
